import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const MailOutlineIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4 8.57139L12 13.1428L20 8.57139M5.14286 5.14282H18.8571C19.4883 5.14282 20 5.6545 20 6.28568V17.7143C20 18.3454 19.4883 18.8571 18.8571 18.8571H5.14286C4.51168 18.8571 4 18.3454 4 17.7143V6.28568C4 5.6545 4.51167 5.14282 5.14286 5.14282Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Box>
  );
};
